import { methods, request } from "./base";

const onboardingApis = {
  requestCallback: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient/request_callback_campaign_info",
      payload: data,
      priv: false,
      encrypt: false,
      headers: {
        "Content-Type": "application/json",
      },
    }),

  sendOtp: async (data: any) => {
    const { payload, headers } = data || {};
    return request({
      method: methods.POST,
      route: "/otp/send",
      priv: false,
      payload,
      headers,
    });
  },
  verifyOtp: async (data: any) => {
    const { payload, headers } = data || {};
    return request({
      method: methods.POST,
      route: "/otp/verify",
      priv: false,
      payload,
      headers,
    });
  },
};

export default onboardingApis;
